import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {
  NextSectionNormalIcon,
  NextSectionHoverIcon,
  PreviousSectionNormalIcon,
  PreviousSectionHoverIcon,
} from '../Icons';
import {Button, Image} from '@learningblocks/shared-components';
import './style.scss';

/**
 * SlideController
 *  - Up and Down arrow buttons displayed in top left corner
 *  - Used to traverse between sections of slide.
 */
export function SlideController(props) {
  return (
    <div className='sectionControls'>
      <PreviousSection toPrevious={props.toPrevious} />
      <NextSection toNext={props.toNext} />
    </div>
  );
}
SlideController.propTypes = {
  /**
   * Callback function to be executed on Previous Button click
   */
  toPrevious: PropTypes.func,
  /**
   * Callback function to be executed on Next Button Click.
   */
  toNext: PropTypes.func,
};

/**
 * PreviousSection
 *  - Button when clicked traverse you to previous section.
 */
function PreviousSection(props) {
  const [highlight, setHighlight] = useState(false);

  const toHighlighted = () => setHighlight(true);

  const toNormal = () => setHighlight(false);

  const goToPrevious = () => {
    props.toPrevious();
  };

  return (
    <Button
      className='sectionControls-previous'
      onClick={goToPrevious}
      onMouseOut={toNormal}
      onMouseOver={toHighlighted}>
      <Image
        src={highlight ? PreviousSectionHoverIcon : PreviousSectionNormalIcon}
        alt='Previous section'
        className='sectionControls-previous__image'
      />
    </Button>
  );
}
PreviousSection.propTypes = {
  /**
   * Callback function to be executed on Button click
   */
  goToPrevious: PropTypes.func,
};

/**
 * NextSection
 *  - Button when clicked traverse to next section in slide
 */
function NextSection(props) {
  const [highlight, setHighlight] = useState(false);

  const toHighlighted = () => setHighlight(true);

  const toNormal = () => setHighlight(false);

  const goToNext = () => {
    props.toNext();
  };

  return (
    <Button
      className='sectionControls-next'
      onClick={goToNext}
      onMouseOut={toNormal}
      onMouseOver={toHighlighted}>
      <Image
        src={highlight ? NextSectionHoverIcon : NextSectionNormalIcon}
        alt='Next section'
        className='sectionControls-next__image'
      />
    </Button>
  );
}
NextSection.propTypes = {
  /**
   * Callback function to be executed on Button Click.
   */
  toNext: PropTypes.func,
};
